<div #wrapper
    class="wrapper">
    @if (mailIcon()) {
    <svg id="mail-icon"
        viewBox="0 0 47 33"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <g id="Group">
            <path id="Vector"
                d="M2 2H44.6012V30.85H2V2Z"
                stroke="currentColor"
                stroke-width="4"
                stroke-linecap="round"
                stroke-linejoin="round" />
            <g id="Vector_2">
                <mask id="path-2-inside-1_982_2181"
                    fill="currentColor">
                    <path
                        d="M45.8447 1.20483L27.7723 14.923C26.489 15.8972 24.9154 16.4255 23.2964 16.4255C21.6773 16.4255 20.1037 15.8972 18.8204 14.923L0.748047 1.20483" />
                </mask>
                <path
                    d="M48.2631 4.39091C50.0227 3.05524 50.3664 0.546006 49.0307 -1.21362C47.6951 -2.97324 45.1858 -3.31692 43.4262 -1.98124L48.2631 4.39091ZM27.7723 14.923L25.3538 11.7369L25.3536 11.7371L27.7723 14.923ZM23.2964 16.4255V12.4255V16.4255ZM18.8204 14.923L21.2391 11.7371L21.2389 11.7369L18.8204 14.923ZM3.1665 -1.98124C1.40687 -3.31692 -1.10236 -2.97324 -2.43803 -1.21362C-3.77371 0.546007 -3.43003 3.05524 -1.6704 4.39091L3.1665 -1.98124ZM43.4262 -1.98124L25.3538 11.7369L30.1907 18.1091L48.2631 4.39091L43.4262 -1.98124ZM25.3536 11.7371C24.7697 12.1804 24.0465 12.4255 23.2964 12.4255V20.4255C25.7843 20.4255 28.2083 19.6141 30.191 18.1089L25.3536 11.7371ZM23.2964 12.4255C22.5462 12.4255 21.823 12.1804 21.2391 11.7371L16.4017 18.1089C18.3844 19.6141 20.8084 20.4255 23.2964 20.4255V12.4255ZM21.2389 11.7369L3.1665 -1.98124L-1.6704 4.39091L16.402 18.1091L21.2389 11.7369Z"
                    fill="currentColor"
                    mask="url(#path-2-inside-1_982_2181)" />
            </g>
        </g>
    </svg>
    }
    @if (climacon()) {
    <span [ngClass]="climacon()"
        aria-hidden="true"></span>
    }
    <div>
        <h2 [class.mail-title]="mailIcon()">{{ title() | translate }}</h2>
        <p #textContent
            [class.transparent]="isMeasuring()"
            [class.overflow]="hasTextOverflow()">
            {{ text() }}
        </p>
    </div>
</div>
